module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjUwMCIgdmlld0JveD0iMCAwIDIwIDEwIj48cGF0aCBmaWxsPSIjMDc4OTMwIiBkPSJNMCAwaDIwdjEwSDB6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMGgyMHY3SDB6Ii8+PHBhdGggZD0iTTAgMGgyMHYzSDB6Ii8+PHBhdGggZmlsbD0iI0RBMTIxQSIgZD0iTTAgMy41aDIwdjNIMHoiLz48cGF0aCBmaWxsPSIjMEY0N0FGIiBkPSJNMCAwbDguNjYgNUwwIDEweiIvPjxwYXRoIGZpbGw9IiNGQ0REMDkiIGQ9Ik0xLjI4NyA1bDIuODk0Ljk0LTEuNzg5LTIuNDYydjMuMDQ0bDEuNzktMi40NjJ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ssd.svg
// module id = cPvi
// module chunks = 0